// V1
import "./OrganizationGallerySummary.css";
import Card from "../../Card";
import Placeholder from "../../Placeholder";
import { ORGANIZATION_MEDIA } from "../../../api/organization";
import { useQuery } from "@apollo/client";
import { useHistory, useLocation } from "react-router-dom";
import Avatar from "../../Avatar/Avatar";
import captureException from "../../../utils/captureException";

function OrganizationGallerySummary({ id, organization }) {
  const history = useHistory();
  const location = useLocation();
  const { loading, error, data } = useQuery(ORGANIZATION_MEDIA, {
    variables: { id, type: "IMAGE", take: 8 },
  });

  if (error) {
    captureException({
      error,
      info: {
        type: "query",
        component: "OrganizationGallerySummary",
        query: "ORGANIZATION_MEDIA",
      },
    });
    console.log(error);
    return <div>Error</div>;
  }

  if (loading || !data) {
    return (
      <Card className="profile-overview-gallery-card">
        <div className="card-title">
          <Placeholder style={{ height: "12px", width: "48px" }} pulse={true} />
        </div>
        <div className="gallery-grid">
          {[1, 2, 3, 4].map((m, i) => (
            <div
              key={"profile-gallery-summary-placeholder-" + i}
              className="gallery-grid-item"
              style={{ background: "var(--blue-subtle)" }}
            >
              <Placeholder
                style={{ height: "100%", width: "100%" }}
                pulse={true}
              />
            </div>
          ))}
        </div>
      </Card>
    );
  }

  const photos = data?.organization?.media || [];

  return (
    <Card className="profile-overview-gallery-card">
      <div className="card-title">
        <div>Photos of {organization.name}</div>
        {!!photos?.length && (
          <div
            className="card-title-link"
            onClick={() => {
              history.replace(location.pathname + "?t=photos");
            }}
          >
            See more photos
          </div>
        )}
      </div>
      {photos.length ? (
        <div className="gallery-grid">
          {photos.map((m) => (
            <div
              key={m.id}
              className="gallery-grid-item hover-pointer"
              onClick={() => {
                history.replace(location.pathname + "?t=photos");
              }}
            >
              <Avatar media={m} />
            </div>
          ))}
        </div>
      ) : (
        <div className="no-data">
          <div>{organization.name} has not been tagged in any photos yet.</div>
        </div>
      )}
    </Card>
  );
}

export default OrganizationGallerySummary;
